import { styled } from "@mui/system";
import Button from "@mui/material/Button";

export const StyledExploreBtn = styled(Button)(({ theme }) => ({
  width: "200px",
  height: "40px",
  borderRadius: "21px",
  textTransform: "capitalize",
  fontSize: "16px",
  fontWeight: 500,
  letterSpacing: "normal",
  "@media (max-width: 372px)": {
    width: "100%",
    marginLeft: 0
  }
}));

export const StyledUploadLimitComponent = styled("div")(({ theme }) => ({
  padding: "100px 0",
  "@media (max-width: 600px)": {
    padding: "0"
  },
  "& .containerText": {
    fontSize: "18px",
    color: "#373737",
    margin: "20px 0 40px",
    lineHeight: "1.5",
    textAlign: "center"
  },
  "& .btnContainer": {
    padding: "5px",
    width: "100%",
    textAlign: "center"
  },
  "& .iconContainer": {
    width: "200px",
    height: "180px",
    marginLeft: "auto",
    marginRight: "auto",
    display: "block",
    "@media (max-width: 600px)": {
      width: "100px",
      height: "110px"
    }
  }
}));
